import {cargoApiURL} from '@logistics-frontend/client-core/api/corp'
import {fetch} from '@logistics-frontend/core/utils/network'
import {constant, find, flow, get, ifElse, isNumber, isString, replace, toLower} from '@logistics-frontend/utils'

import * as t from './types'

const toSnakeCase = flow(toLower, replace(/ /g, '_'))
const getZoneName = flow(get('en_name'), ifElse(isString, toSnakeCase, constant(undefined)))
const findZoneName = (zone: string = '') =>
  flow(
    find(({name}) => name.includes(zone)),
    get('name'),
  )

export const fetchRegionByID = (geoid?: number): Promise<t.RegionByGeoIDResponse | undefined> => {
  return isNumber(geoid) ? fetch({url: `/geobase/api/v1/region_by_id?id=${geoid}`}) : Promise.resolve(undefined)
}

export const fetchCountryInfo = (countryCode: string): Promise<t.CountryInfo> => {
  return fetch({
    url: cargoApiURL('cargo-corp/v1/country/info'),
    method: 'POST',
    body: {
      country_alpha3: countryCode,
    },
  })
}

export const fetchCountryByCode = (code: string) => fetchCountryInfo(code).then(get('id.geoid'))
export const fetchCapitalID = (geoid?: number) => fetchRegionByID(geoid).then(get('capital_id'))
export const fetchZoneName = (geoid?: number) => fetchRegionByID(geoid).then(getZoneName)

export const fetchZoneByCountryCode = (code: string) =>
  fetchCountryByCode(code).then(fetchCapitalID).then(fetchZoneName)

export const fetchTariffZoneName = async (
  tariffZones: t.TariffZonesItem[],
  countryCode?: string,
  zone?: string,
  fallbackZone?: string,
): Promise<string | undefined> => {
  if (!countryCode) {
    return zone
  }

  const tariffZone = zone ? findZoneName(zone)(tariffZones) : undefined

  try {
    const zoneName =
      tariffZone ||
      (await fetchZoneByCountryCode(countryCode).then(zone => findZoneName(zone)(tariffZones))) ||
      fallbackZone

    return zoneName
  } catch (e) {
    return fallbackZone
  }
}
